module.exports = __webpack_public_path__ + "static/fonts/BM-fonts-package.zip?1d632d9d";